import QueueAPI from '@/api/queue'
import SoundService from "@/services/sound";

let isFirstRequest = true;

const state = {
    list: []
};

const mutations = {
    setList(state, payload) {
        state.list = payload;
    }
};

const actions = {
    fetchReservations(context) {
        return new Promise((resolve, reject) => {
            QueueAPI.getReserveList().then(data => {
                if (!isFirstRequest && context.state.list.length < data.list.length) {
                    SoundService.playNewOrder();
                }

                context.commit('setList', data.list);
                resolve();

                isFirstRequest = false;
            }).catch(error => {
                context.commit('setError', error, {root: true}); 
            });
        });
    },
    cancelReservation(context, payload) {
        return new Promise((resolve, reject) => {
            QueueAPI.cancelReservation(
                payload.reservation._id,
                payload.reason
            ).then(data => {
                context.dispatch('fetchReservations');
                resolve();
            }).catch(error => {
                context.commit('setError', error, { root: true });
                reject();
            });
        });
    },
    acceptReservation(context, payload) {
        return new Promise((resolve, reject) => {
            QueueAPI.acceptReservation(
                payload._id
            ).then(data => {
                context.dispatch('fetchReservations');
                resolve();
            }).catch(error => {
                context.commit('setError', error, { root: true });
                reject();
            });
        });
    }
};

const getters = {
    needAttentionCount(state) {
        return state.list.filter(r => r.status == 'confirmed').length;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}